import React, { useEffect, useState } from "react";
import DataTable from '../../components/DataTablePtBr';
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import api from "../../services/api";
import { showError } from "../../services/alert";

export default function RelAgriPropriedade() {
  const [propriedades, setPropriedades] = useState([]);
  const [propriedadeId, setPropriedadeId] = useState("");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // 🔹 Carrega as propriedades no dropdown
  useEffect(() => {
    api
      .get("/propriedades")
      .then((res) => setPropriedades(res.data || []))
      .catch((err) => {
        console.error("Erro ao carregar propriedades:", err.response?.data || err.message);
      });
  }, []);

  // 🔹 Consulta relatório da propriedade
  const carregar = async () => {
    if (!propriedadeId) {
      showError("Selecione uma propriedade.");
      return;
    }
    setLoading(true);
    try {
      const res = await api.get(`/relatorios/agricola/propriedade/${propriedadeId}`);
      setData(res.data);
    } catch (err) {
      console.error("Erro ao carregar relatório:", err.response?.data || err.message);
      showError("Erro ao carregar relatório.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Gera e baixa CSV autenticado
  const gerarCsv = async () => {
    try {
      const res = await api.get(`/relatorios/agricola/propriedade/${propriedadeId}/csv`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "relatorio-propriedade.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Erro ao gerar CSV:", err);
      showError("Não foi possível gerar o arquivo CSV.");
    }
  };

  // 🔹 Gera e abre PDF autenticado
  const gerarPdf = async () => {
    try {
      const res = await api.get(`/relatorios/agricola/propriedade/${propriedadeId}/pdf`, {
        responseType: "blob",
      });
      const blob = new Blob([res.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
    } catch (err) {
      console.error("Erro ao gerar PDF:", err);
      showError("Não foi possível gerar o arquivo PDF.");
    }
  };

  // 🔹 Colunas da tabela
  const columns = [
    { name: "Talhão", selector: (r) => r.nome, sortable: true },
    { name: "Área (ha)", selector: (r) => r.areaHa, className: "text-end", sortable: true },
    {
      name: "Ativo",
      selector: (r) => (r.ativo ? "Sim" : "Não"),
      width: "120px",
      className: "text-center",
    },
  ];

  return (
    <div className="container mt-4">
      <Header />

      <div className="card shadow-lg border-0 rounded-3">
        {/* Cabeçalho */}
        <div className="card-header bg-success text-white d-flex justify-content-between align-items-center rounded-top-3">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-light btn-sm d-flex align-items-center gap-1"
              onClick={() => navigate("/menu")}
              disabled={loading}
            >
              <i className="bi bi-arrow-left text-success" />
              <span className="text-success fw-semibold">Voltar</span>
            </button>

            <div>
              <h5 className="mb-0">Relatório por Propriedade</h5>
              <small className="text-white-50">Talhões e áreas</small>
            </div>
          </div>

          <div className="d-flex gap-2">
            {data && (
              <>
                <button
                  className="btn btn-light text-success fw-bold d-flex align-items-center gap-1"
                  onClick={gerarCsv}
                  disabled={loading}
                >
                  <i className="bi bi-download" />
                  <span>CSV</span>
                </button>

                <button
                  className="btn btn-light text-success fw-bold d-flex align-items-center gap-1"
                  onClick={gerarPdf}
                  disabled={loading}
                >
                  <i className="bi bi-filetype-pdf" />
                  <span>PDF</span>
                </button>
              </>
            )}
          </div>
        </div>

        {/* Corpo */}
        <div className="card-body">
          <div className="row g-3 mb-3">
            <div className="col-md-6">
              <label className="form-label fw-semibold">Propriedade</label>
              <select
                className="form-select rounded-3"
                value={propriedadeId}
                onChange={(e) => setPropriedadeId(e.target.value)}
                disabled={loading}
              >
                <option value="">Selecione...</option>
                {(propriedades || []).map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.nome}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6 d-flex align-items-end">
              <button
                className="btn btn-success d-flex align-items-center gap-1"
                onClick={carregar}
                disabled={loading}
              >
                <i className="bi bi-search" />
                <span>{loading ? "Carregando..." : "Consultar"}</span>
              </button>
            </div>
          </div>

          {/* Resultado */}
          {data && (
            <>
              <div className="mb-2">
                <strong>{data.propriedadeNome}</strong> — Talhões: {data.totalTalhoes} | Área total:{" "}
                {data.areaTotalHa} ha
              </div>

              <DataTable
                columns={columns}
                data={data.talhoes || []}
                pagination
                responsive
                highlightOnHover
                striped
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
}
